export default "__VITE_ASSET__e66817d6__"